import type { MetaDescriptor } from '@remix-run/node';
import { SITE_METADATA, type SeoInput } from '~/lib/site-metadata';

export function buildMeta({
  title,
  description,
  image,
  noindex,
  canonical,
}: SeoInput = {}): MetaDescriptor[] {
  const computedTitle = title ? `${title} | ${SITE_METADATA.title}` : SITE_METADATA.title;
  const computedDescription = description ?? SITE_METADATA.description;
  const canonicalUrl = canonical ?? SITE_METADATA.url;
  const imageUrl = image ?? `${SITE_METADATA.url}/og-image.jpg`;

  const meta: MetaDescriptor[] = [
    { title: computedTitle },
    { name: 'description', content: computedDescription },
    { property: 'og:title', content: computedTitle },
    { property: 'og:description', content: computedDescription },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:image', content: imageUrl },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: computedTitle },
    { name: 'twitter:description', content: computedDescription },
    { name: 'twitter:image', content: imageUrl },
  ];

  if (noindex) {
    meta.push({ name: 'robots', content: 'noindex,nofollow' });
  }

  return meta;
}
